export default class PaymentCompletionType {
  static get Manual () { return 'manual' }
  static get Integration () { return 'integration' }

  static getName (enumValue) {
    switch (enumValue) {
      case PaymentCompletionType.Manual:
        return 'Вручную'
      case PaymentCompletionType.Integration:
        return 'По интеграции'
      default:
        return enumValue
    }
  }
}
